// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.1.0",
  "buildDate": "2026-10-21T18:36:05.255Z"
};

export default buildInfo;
